import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  Table
} from 'semantic-ui-react';

import * as data from './editor/data';

const buildSet = (identifier, dataSet) => {
  let set = [];

  dataSet.forEach((item, index) => {
    if (identifier === 'e') {
      let obj = JSON.parse(item[1]);
      set.push({
        key: `key${obj.id}.${obj.subtype}.${obj.variant}`,
        text: item[0],
        value: `${obj.id}.${obj.subtype}.${obj.variant}`,
      })
    } else {
      set.push({
        key: `key${identifier}${item[1]}`,
        text: item[0],
        value: `${identifier}${item[1]}`,
      })
    }
  })

  return set.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
}

const mapping = {
  'active': {
    'title': 'Active Items',
    'data': buildSet('ai', data.ActiveCollectibles),
  },
  'card': {
    'title': 'Cards/Runes',
    'data': buildSet('k', data.Cards),
  },
  'character': {
    'title': 'Characters',
    'data': buildSet('i', data.Characters),
  },
  'collectible': {
    'title': 'Collectibles',
    'data': buildSet('c', data.Collectibles),
  },
  'costume': {
    'title': 'Costumes',
    'data': buildSet('d', data.Costumes),
  },
  'curse': {
    'title': 'Curses',
    'data': buildSet('x', data.Curses),
  },
  'enemy': {
    'title': 'Enemies',
    'data': buildSet('e', data.Enemies),
  },
  'passive': {
    'title': 'Passive Items',
    'data': buildSet('pi', data.PassiveCollectibles),
  },
  'pill': {
    'title': 'Pills',
    'data': buildSet('p', data.Pills),
  },
  'room': {
    'title': 'Rooms',
    'data': buildSet('r', data.Rooms),
  },
  'trinket': {
    'title': 'Trinkets',
    'data': buildSet('t', data.Trinkets),
  },
}

const CommandConfigBanned = ({ update, config, params }) => {
  const [blocks, setBlocks] = useState([]);

  const updateBanned = (event, data) => {
    update('banned', data.value)
    config.banned = data.value;
  }

  useEffect(() => {
    for (let param in params) {
      switch (params[param].type) {
        case 'givable':
          setBlocks(source => [...source, mapping['card']]);
          setBlocks(source => [...source, mapping['collectible']]);
          setBlocks(source => [...source, mapping['pill']]);
          setBlocks(source => [...source, mapping['trinket']]);
          break;
        case 'spawnable':
          setBlocks(source => [...source, mapping['card']]);
          setBlocks(source => [...source, mapping['collectible']]);
          setBlocks(source => [...source, mapping['pill']]);
          setBlocks(source => [...source, mapping['trinket']]);
          setBlocks(source => [...source, mapping['enemy']]);
          break;
        case 'takable':
          setBlocks(source => [...source, mapping['collectible']]);
          setBlocks(source => [...source, mapping['trinket']]);
          break;
        default:
          console.log(params[param].type)
          if (params[param].type in mapping) {
            setBlocks(source => [...source, mapping[params[param].type]]);
          }
          break;
      }

      console.log(params[param]);
    }
  }, [params]);

  useEffect(() => {
    console.log(blocks);
  }, [blocks]);

  return (
    <React.Fragment>
      {Object.values(blocks).map((block, index) =>
        <Table.Row>
          <Table.Cell collapsing verticalAlign='top'><strong>Banned {block.title}</strong></Table.Cell>
          <Table.Cell>
            <Dropdown
              placeholder={block.title}
              fluid
              multiple
              selection
              search
              scrolling
              options={block.data}
              value={config && config.hasOwnProperty('banned') ? config.banned : []}
              onChange={updateBanned}
            />
          </Table.Cell>
        </Table.Row>
      )}
    </React.Fragment>
  )
}

export default CommandConfigBanned;
